const publicLinks = {
  singin: "signin",
  forgotPassword: "forgot-password",
  setPassword: "set-password",
  completeRegistration: "newAccount",
  confirmEmail: "confirm-email",
  forbidden: "forbidden",
  qbConnection: "connection-established",
  estimates: "client/quote/:id",
};

const adminToolLinks = {
  users: "users",
  quickBooks: "quick-books",
  settings: "settings",
  features: "features",
  notificationDetails: "settings/notifications/:id",
};

const hostToolLinks = {
  tenants: "tenants",
  tenantDetails: "tenants/:tenantId",
  features: "features",
  featureDetails: "features/:featureId",
  admins: "admins",
  roles: "roles",
};

const technichianToolLinks = {
  schedule: "schedule",
  companyList: "companies",
  companySales: "sales",
  companyMap: "companies/list/map",
  companiesDetails: "companies/:id",
  vehiclesList: "vehicles",
  vehiclesCreate: "vehicles/create",
  vehiclesEdit: "vehicles/edit/:id",
  quotesList: "estimates",
  quotesCreate: "estimates/create",
  quotesEdit: "estimates/edit/:id",
  quotesView: "estimates/view/:id",
  quotesDetails: "estimates/:id",
  estimatesNew: "estimates/new",
  contactsList: "contacts",
  contactsCreate: "contacts/create",
  contactsEdit: "contacts/edit/:id",
  equipmentList: "equipment",
  equipmentCreate: "equipment/create",
  equipmentEdit: "equipment/edit/:id",
  notesList: "companies/notes",
  notesCreate: "companies/notes/create",
  notesEdit: "companies/notes/edit/:id",
  equipmentMakesList: "equipment/makes",
  equipmentMakesCreate: "equipment/makes/create",
  equipmentMakesEdit: "equipment/makes/edit/:id",
  equipmentTypesList: "equipment/types",
  equipmentTypesCreate: "equipment/types/create",
  equipmentTypesEdit: "equipment/types/edit/:id",
  equipmentModelsList: "equipment/models",
  equipmentModelsCreate: "equipment/models/create",
  equipmentModelsEdit: "equipment/models/edit/:id",
  workOrderCreate: "work-orders/create",
  workOrderDetails: "work-orders/:id",
  workOrdersNotesCreate: "work-orders/notes/create",
  workOrdersNotesEdit: "work-orders/notes/edit/:id",
  workOrdersList: "work-orders",
  myProfile: "profile",
  payroll: "payroll",
  items: "items",
  vendors: "vendors",
  vendorsDetails: "vendors/:id",
};

const clientAppLinks = {};

export { publicLinks, adminToolLinks, clientAppLinks, technichianToolLinks, hostToolLinks };
